export const INFO_SET = 'INFO_SET';
export const INFO_LOADED = 'INFO_LOADED';
export const INFO_GET_ERROR = 'INFO_GET_ERROR';
export const INFO_REFRESH = 'INFO_REFRESH';
